'use client';

import { Suspense } from 'react';
import GoogleAnalytics from './google-analytics';
import GoogleTagManager from './google-tag-manager';

// Analytics wrapper with proper error handling
export default function AnalyticsWrapper() {
  return (
    <>
      {/* Google Tag Manager */}
      <GoogleTagManager />
      
      {/* Google Analytics with Suspense boundary */}
      <Suspense fallback={null}>
        <GoogleAnalytics />
      </Suspense>
    </>
  );
}
